import { toZonedTime } from "date-fns-tz";

function convertTime(value: number, fromUnit: string, toUnit: string): number {
  const unitMap: { [key: string]: number } = {
    days: 3600 * 24,
    hours: 3600,
    minutes: 60,
    seconds: 1,
    milliseconds: 0.001,
  };

  return value * (unitMap[fromUnit] / unitMap[toUnit]);
}

function millisecondsToSeconds(value: number): number {
  return convertTime(value, "milliseconds", "seconds");
}

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

function dateToTimeZone(date: Date, timeZone: string): Date {
  return toZonedTime(date, timeZone);
}

export { formatTime, millisecondsToSeconds,dateToTimeZone };
